import experiments from '@reverbdotcom/commons/src/experiments';
import { camelCase, lowerCase } from 'lodash';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';

export const DRAFT = 'draft';
export const LIVE = 'live';
export const ENDED = 'ended';
export const ORDERED = 'ordered';
export const SUSPENDED = 'suspended';
export const SOLD_OUT = 'sold_out';
export const SELLER_UNAVAILABLE = 'seller_unavailable';

export const VALID_DIRECT_OFFER_STATES = [
  LIVE,
  ENDED,
];

export function queryParamState(window) {
  const urlParams = new URLSearchParams(window.location.search);
  return camelCase(lowerCase(urlParams.get('state')));
}

function isLive(window) {
  return LIVE === queryParamState(window);
}

export function isPageEligibleForBulkAffirm(window) {
  return isLive(window);
}

export function isPageEligibleForBulkSales(window) {
  return isLive(window);
}

export function isPageEligibleForBulkBump(window) {
  return isLive(window);
}

export function isPageEligibleForBulkDirectOffers(window) {
  return VALID_DIRECT_OFFER_STATES.includes(queryParamState(window));
}

export function isPageEligibleForBulkDraftActions(window) {
  return DRAFT === queryParamState(window);
}

export function useValidForBulkSelect(window) {
  if (useExpEnabled(experiments.LISTINGS_MANAGEMENT_SORTING_AND_FILTERING)) return true;
  return isPageEligibleForBulkDraftActions(window);
}
